import AtlaskitPagination from '@qality/common-components/src/atoms/atlaskit/Pagination';
import type { PaginationPropTypes } from '@qality/common-components/src/atoms/atlaskit/Pagination';

export interface PaginationViewProps extends PaginationPropTypes {}

export const PaginationView = AtlaskitPagination;
